import { render, staticRenderFns } from "./GreenSpirit.vue?vue&type=template&id=be139380&"
import script from "./GreenSpirit.vue?vue&type=script&lang=js&"
export * from "./GreenSpirit.vue?vue&type=script&lang=js&"
import style0 from "./GreenSpirit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports